// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import './PartnerActionButtons.scss';

type Props = {
  id: string,
  onAskRemove: () => void,
};

const PartnerActionButtons = ({ id, onAskRemove }: Props) => (
  <div className="PartnerActionButtons">
    <Link to={`/write?edit_id=${id}&type=partner`} className="btn">
      수정
    </Link>
    <button className="btn" onClick={onAskRemove}>
      삭제
    </button>
  </div>
);

export default PartnerActionButtons;



// WEBPACK FOOTER //
// ./src/components/partner/PartnerActionButtons/PartnerActionButtons.js